import type { Props } from './Svg'
import { Svg } from './Svg'

export function NoDemandsAvailable(props: Props) {
  return (
    <Svg width="424" height="271" fill="none" stroke="none" {...props}>
      <path
        fill="#F2F2F2"
        d="m146.05 252.96-12.98 7.53 12.8-3.09a38.33 38.33 0 0 1-.58 3.95 23.2 23.2 0 0 1-3.67 8.87h-34.4a16.1 16.1 0 0 1-3.58-12.98 22.92 22.92 0 0 1 1.36-5.01 32.81 32.81 0 0 1 1.97-4.19c1.57-2.84 4.03-5.4 6.92-7.67a48.34 48.34 0 0 1 5.25-3.58l1.37-.79a61.44 61.44 0 0 1 3.46-1.84 93.16 93.16 0 0 1 6.58-2.96 104.3 104.3 0 0 1 11.5-3.94l.04.11c.06.2.21.7.41 1.44.56 2.03 1.55 5.92 2.34 10.6l.13.78a81.25 81.25 0 0 1 1.1 12v.75l-.02.02Z"
      />
      <path
        fill="#fff"
        d="M143 226.8c0 .01-.04.23-.15.64l-.35 1.37c-.52 2-1.45 5.35-2.78 9.39l-.23.71a155.84 155.84 0 0 1-4.55 11.97 103.22 103.22 0 0 1-4.29 8.82l-.37.67a60.22 60.22 0 0 1-6.81 9.85h-1.04l.93-1.07a59.24 59.24 0 0 0 6.2-9.13l.38-.66a103.88 103.88 0 0 0 4.6-9.54 148.66 148.66 0 0 0 4.46-11.91 159.4 159.4 0 0 0 3.22-11.08l.05-.2.37.09.37.08Z"
      />
      <path
        fill="#fff"
        d="M145.52 239.48a19.76 19.76 0 0 1-5.8-1.28l-.72-.3a20.76 20.76 0 0 1-8.62-6.93l-.72.3.17.22a20.93 20.93 0 0 0 9.66 7.42 20.97 20.97 0 0 0 6.15 1.34l-.12-.77ZM146.06 252.2a20.31 20.31 0 0 1-18.8-9.01c-1.8-2.7-2.93-5.8-3.3-9.03l-.02-.23-.72.37.03.22a21.13 21.13 0 0 0 10.71 15.85l.28.15.7.36a21.06 21.06 0 0 0 11.1 2.07l.61-.06v-.76c-.2.02-.39.05-.59.06Z"
      />
      <path
        fill="#fff"
        d="M145.45 260.51A20.39 20.39 0 0 1 118.72 240c.05-1.08.2-2.15.42-3.2l.05-.22-.88.56-.04.2a21.15 21.15 0 0 0 27.52 23.88l.18-.87-.52.18Z"
      />
      <path
        fill="#9E616A"
        d="M114.7 110.35H89.63v25.06h25.07v-25.06ZM74 260.16h4.94l2.35-19.05H74v19.05Z"
      />
      <path
        fill="#2F2E41"
        d="m87.56 265.73-7.42-5.13v-3.34l-.85.05-5.29.31-1.67.1-.95 11.43-.03.38h3.5l.07-.38.56-2.92 1.42 2.92.18.38h9.3a2.1 2.1 0 0 0 1.18-3.8Z"
      />
      <path fill="#9E616A" d="m102.89 257.02 4.74 1.37 7.53-17.66-7.01-2.01-5.27 18.3Z" />
      <path
        fill="#2F2E41"
        d="m114.37 266.12-5.71-6.98.92-3.2-.82-.2-4.59-1.02-.58-.13-1.64-.37-4.21 11.08 3.37.97 1.51-3 .63 3.61 2.12.61 5.77 1.66 1.04.3a2.09 2.09 0 0 0 2.2-3.33Z"
      />
      <path
        fill="#E4E4E4"
        d="M422.54 0H160.92a1.47 1.47 0 0 0-1.46 1.47v8.61a1.47 1.47 0 0 0 1.47 1.47h261.6a1.47 1.47 0 0 0 1.47-1.47V1.47A1.47 1.47 0 0 0 422.54 0Z"
      />
      <path
        fill="#fff"
        d="M167.97 7.44a2.08 2.08 0 1 0 0-4.16 2.08 2.08 0 0 0 0 4.16ZM175.86 7.44a2.08 2.08 0 1 0 0-4.17 2.08 2.08 0 0 0 0 4.17ZM183.76 7.44a2.08 2.08 0 1 0 0-4.17 2.08 2.08 0 0 0 0 4.17ZM414.8 2.58h-9.1a.67.67 0 0 0-.47 1.15c.13.12.3.2.48.2h9.09a.67.67 0 0 0 .47-1.15.67.67 0 0 0-.47-.2ZM414.8 5.1h-9.1a.68.68 0 0 0-.67.68.67.67 0 0 0 .68.67h9.09a.67.67 0 1 0 0-1.35ZM414.8 7.63h-9.1a.67.67 0 0 0-.47 1.15c.13.12.3.2.48.2h9.09a.67.67 0 0 0 .47-1.16.67.67 0 0 0-.47-.2Z"
      />
      <path
        fill="#E4E4E4"
        d="M413.76 36.48h-67.78a1.79 1.79 0 0 0-1.78 1.78v27.5a1.78 1.78 0 0 0 1.78 1.79h67.78a1.78 1.78 0 0 0 1.79-1.79v-27.5a1.79 1.79 0 0 0-1.79-1.78ZM407.3 76.46h-54.86a2.13 2.13 0 1 0 0 4.28h54.87c2.78.04 2.76-4.32 0-4.28ZM407.3 86.26h-54.86a2.13 2.13 0 1 0 0 4.27h54.87c2.78.05 2.76-4.31 0-4.27ZM407.3 96.06h-54.86a2.13 2.13 0 1 0 0 4.27h54.87c2.78.04 2.76-4.31 0-4.27ZM324.69 36.48H256.9a1.79 1.79 0 0 0-1.79 1.78v27.5a1.79 1.79 0 0 0 1.79 1.79h67.78a1.78 1.78 0 0 0 1.78-1.79v-27.5a1.78 1.78 0 0 0-1.78-1.78ZM318.23 76.46h-54.87a2.14 2.14 0 0 0 0 4.28h54.87c2.79.04 2.76-4.32 0-4.28ZM318.23 86.26h-54.87a2.14 2.14 0 0 0 0 4.27h54.87c2.79.05 2.76-4.31 0-4.27ZM318.23 96.06h-54.87a2.14 2.14 0 0 0 0 4.27h54.87c2.79.04 2.76-4.31 0-4.27Z"
      />
      <path
        fill="#9E616A"
        d="M154.72 88.5c-.08.25-.15.51-.18.78l-27.76-4.9-23.9-12.9a6.75 6.75 0 0 0-7.2 11.38 53.25 53.25 0 0 0 14.64 7.6l17.34 5.81L158 94.33a4.47 4.47 0 1 0-3.28-5.83Z"
      />
      <path
        fill="#1FBE4C"
        d="M223 88.58h-86.4a2.28 2.28 0 0 0-2.28 2.28v35.05a2.28 2.28 0 0 0 2.27 2.27H223a2.28 2.28 0 0 0 2.27-2.27V90.86a2.28 2.28 0 0 0-2.27-2.28ZM214.76 139.55h-69.94a2.72 2.72 0 1 0 0 5.45h69.94c3.55.05 3.52-5.5 0-5.45ZM214.76 152.03h-69.94a2.73 2.73 0 0 0 0 5.46h69.94c3.55.05 3.52-5.5 0-5.46ZM214.76 164.53h-69.94a2.72 2.72 0 0 0-1.04 5.24c.33.13.68.2 1.04.2h69.94c3.55.05 3.52-5.5 0-5.44Z"
      />
      <path
        fill="#9E616A"
        d="M115.2 59.04a13.3 13.3 0 1 0-23.35-12.77 13.3 13.3 0 0 0 23.35 12.77Z"
      />
      <path
        fill="#2F2E41"
        d="M105.75 36.49h-8.6c-5.63 0-10.2 5.14-10.2 11.48-4.25 4.27-2.98 9.62.4 15.38a66.79 66.79 0 0 1 17.7 4.73l.8-3.43 1.58 4.52c1.4.68 2.8 1.42 4.19 2.23-1.62-7.58-2.28-15.15-1.17-21.03h2.9v-3.19l1 3.19h5.27a13.88 13.88 0 0 0-13.87-13.88Z"
      />
      <path
        fill="#CACACA"
        d="m104.85 69.61-16.1-.7-.42 1.65a95.64 95.64 0 0 0-1.61 41.43 3.69 3.69 0 0 1 1.04 3.59l-.23.92.02.03a5.4 5.4 0 0 1 .72 4.03l.8 4.44 26.08-11.52 5.82-20.14-16.12-23.73Z"
      />
      <path
        fill="#9E616A"
        d="M144.74 112.07c-.18.2-.34.41-.49.64l-23.5-15.56-16.79-21.35a6.75 6.75 0 0 0-11.14 7.57 53.26 53.26 0 0 0 10.4 12.81l13.6 12.23 28.61 10.31a4.47 4.47 0 1 0-.7-6.65Z"
      />
      <path fill="#E4E4E4" d="M195.84 67.44a12.86 12.86 0 1 1 0-25.72 12.86 12.86 0 0 1 0 25.72Z" />
      <path
        fill="#fff"
        d="M200.92 53.3h-3.8v-3.8a1.27 1.27 0 0 0-2.54 0v3.8h-3.81a1.27 1.27 0 0 0 0 2.55h3.8v3.8a1.27 1.27 0 0 0 2.54 0v-3.8h3.81a1.27 1.27 0 1 0 0-2.54Z"
      />
      <path
        fill="#2F2E41"
        d="M131.7 211.03a7.55 7.55 0 0 0-.7-6.75l-11.38-59.02-4.47-22.38H88.29s-16.78 18.58-13.2 42.3l-1 33.4a12.29 12.29 0 0 0-.68 7.25l.4 1.9-.15.28a9.55 9.55 0 0 0-.12 8.85L72.4 254.7l8.06-.45 11.86-44.09 7.83-39.61 13.2 30.66.46 7.16-.22 6.32-10.3 36.88 8.72 3.35 19.7-43.89Z"
      />
      <path
        fill="#CACACA"
        d="M196.8 269.69a.53.53 0 0 1-.53.53H.53a.53.53 0 1 1 0-1.07h195.74a.55.55 0 0 1 .38.16.52.52 0 0 1 .16.38Z"
      />
    </Svg>
  )
}
